module.exports = __webpack_public_path__ + "static/media/become-img-2.04655060.png";